import { RealEstateStrategyColor, RealEstateStrategySlug } from 'types/real-estate-strategy';

export const realEstateStrategySlugs: Array<RealEstateStrategySlug> = [
	'fixed-income',
	'core-plus',
	'value-add',
	'opportunistic'
];

export const realEstateStrategyColors: Array<RealEstateStrategyColor> = [
	{
		name: 'Fixed Income',
		color: '#3C3CCF',
		slug: realEstateStrategySlugs[0]
	},
	{
		name: 'Core Plus',
		color: '#4D7FE5',
		slug: realEstateStrategySlugs[1]
	},
	{
		name: 'Value Add',
		color: '#EFA046',
		slug: realEstateStrategySlugs[2]
	},
	{
		name: 'Opportunistic',
		color: '#b71b1b',
		slug: realEstateStrategySlugs[3]
	}
];
